/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountSettingsForm } from '../models/AccountSettingsForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountSettingsControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateAccount({
        requestBody,
    }: {
        requestBody: AccountSettingsForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/account',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
